export default __webpack_public_path__ + "static/media/book-3.8eebb469.jpeg";